import { DcBaseComponent } from '@deleteagency/dc';
import { _ } from 'core-js';

export default class SearchFiltersBedroomComponent extends DcBaseComponent {
    static getNamespace() {
        return 'filter-bedrooms';
    } 

    onInit() {
        
        this.wrapper = document.querySelector('.js-bedroom-wrapper');
        this.trigger = document.querySelector('.js-bedroom');
        this.dropdown = document.querySelector('.js-bedroom-inner');
        this.bedroomText = document.querySelector('.js-bedroom-text');
        this.bedroomFrom = document.querySelector('.js-bedroom-from');
        this.bedroomTo = document.querySelector('.js-bedroom-to');
        this.bedroomModalFrom = document.querySelector('.js-bedroom-modal-from');
        this.bedroomModalTo = document.querySelector('.js-bedroom-modal-to');
        this.outer = this.trigger.parentElement.parentElement;
        

        setTimeout(() => {
            this._setText(this.bedroomFrom.value, this.bedroomTo.value);
        } , 100);


        this.trigger.addEventListener('click', () => {
            if (this.dropdown.classList.contains('active')) {
                this._closeDropdown();
            } else {
                this._openDropdown();
            }
        });

        this.trigger.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                if (this.dropdown.classList.contains('active')) {
                    this._closeDropdown();
                } else {
                    this._openDropdown();
                }
            }
        });

        // keyboard event return to trigger 
        this.dropdown.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this._closeDropdown();
            }
        });
        
        // if click outside the bounding box of the dropdown, close the dropdown
        document.addEventListener('click', (event) => {
            if ( event.composedPath().includes(this.wrapper) || event.composedPath().includes(this.trigger) || event.composedPath().includes(this.dropdown)) {            
              return;
            }
            this._closeDropdown();          
        });

        // if focus outside of dropdown or trigger, close dropdown
        document.addEventListener('focus', (event) => {
            if ( event.composedPath().includes(this.wrapper) || event.composedPath().includes(this.trigger) || event.composedPath().includes(this.dropdown)) {            
              return;
            }
            this._closeDropdown();          
        });          

        this.bedroomFrom.addEventListener('change', () => {
            const optionsTo = this.bedroomTo.querySelectorAll('option');
            const optionsModalTo = this.bedroomModalTo.querySelectorAll('option');
            const optionsModalFrom = this.bedroomModalFrom.querySelectorAll('option');

            this._setText( this.bedroomFrom.value, this.bedroomTo.value );  

            optionsModalFrom.forEach(option => {
                (option.value == this.bedroomFrom.value) ? (option.setAttribute('selected', true)) : (option.removeAttribute('selected'));
            });

            // set the options in bedroomTo that have a value below the selected bedroomFrom to disabled and hide them
            optionsTo.forEach(option => {
                if (option.value <= this.bedroomFrom.value) {
                    if (option.value !== '') {
                        option.setAttribute('disabled', true);
                        option.removeAttribute('selected');
                        option.selected = false;
                        option.style.display = 'none';
                    }                    
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = 'block';
                }
            });

            optionsModalTo.forEach(option => {
                if (option.value <= this.bedroomModalFrom.value) {
                    if (option.value !== '') {
                        option.setAttribute('disabled', true);
                        option.removeAttribute('selected');
                        option.selected = false;
                        option.style.display = 'none';
                    }                    
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = 'block';
                }
            });
        });

        this.bedroomModalFrom.addEventListener('change', () => {

            const optionsTo = this.bedroomTo.querySelectorAll('option');
            const optionsModalTo = this.bedroomModalTo.querySelectorAll('option');
            const optionsFrom = this.bedroomFrom.querySelectorAll('option');

            this._setText( this.bedroomModalFrom.value, this.bedroomModalTo.value );

            optionsFrom.forEach(option => {
                (option.value == this.bedroomModalFrom.value) ? (option.setAttribute('selected', true)) : (option.removeAttribute('selected'));
            });

            // set the options in bedroomTo that have a value below the selected bedroomFrom to disabled and hide them
            optionsTo.forEach(option => {
                if (option.value <= this.bedroomModalFrom.value) {
                    if (option.value !== '') {
                        option.setAttribute('disabled', true);
                        option.removeAttribute('selected');
                        option.selected = false;
                        option.style.display = 'none';
                    }
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = 'block';
                }
            });

            optionsModalTo.forEach(option => {
                if (option.value <= this.bedroomModalFrom.value) {
                    if (option.value !== '') {
                        option.setAttribute('disabled', true);
                        option.removeAttribute('selected');
                        option.selected = false;
                        option.style.display = 'none';
                    }
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = 'block';
                }
            });
        });


        this.bedroomTo.addEventListener('change', () => {
            
            const optionsFrom = this.bedroomFrom.querySelectorAll('option');
            const optionsModalFrom = this.bedroomModalFrom.querySelectorAll('option');                 
            const optionsModalTo = this.bedroomModalTo.querySelectorAll('option');

            this._setText(
                this.bedroomFrom.value,
                this.bedroomTo.value
            );

            optionsModalTo.forEach(option => {
                if (option.value == this.bedroomTo.value) {
                    option.setAttribute('selected', true);
                } else {
                    option.removeAttribute('selected');
                }
            });            
            
            if (this.bedroomTo.value === '' || this.bedroomModalTo.value === '') {
                optionsFrom.forEach(option => {                    
                    option.removeAttribute('disabled');
                    option.style.display = '';
                });
                optionsModalFrom.forEach(option => {                    
                    option.removeAttribute('disabled');
                    option.style.display = '';
                });
                return;
            }
              
            // set the options in bedroomFrom that have a value above the selected bedroomFrom to disabled and hide them
            optionsFrom.forEach(option => {
                if (option.value > this.bedroomTo.value) {
                    if (option.value !== '') {
                        option.setAttribute('disabled', true);
                        option.removeAttribute('selected');
                        option.selected = false;
                        option.style.display = 'none';
                    }                    
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = '';
                }
            });

            optionsModalFrom.forEach(option => {
                if (option.value > this.bedroomModalTo.value) {
                    if (option.value !== '') {
                        option.setAttribute('disabled', true);
                        option.removeAttribute('selected');
                        option.selected = false;
                        option.style.display = 'none';
                    }                    
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = '';
                }
            });

        });

        this.bedroomModalTo.addEventListener('change', () => {
            
            const optionsFrom = this.bedroomFrom.querySelectorAll('option');
            const optionsModalFrom = this.bedroomModalFrom.querySelectorAll('option');                 
            const optionsTo = this.bedroomTo.querySelectorAll('option');

            this._setText(
                this.bedroomModalFrom.value,
                this.bedroomModalTo.value
            );
                
            optionsTo.forEach(option => {
                if (option.value == this.bedroomModalTo.value) {
                    option.setAttribute('selected', true);
                } else {
                    option.removeAttribute('selected');
                }
            });

            if (this.bedroomTo.value === '' || this.bedroomModalTo.value === '') {
                optionsFrom.forEach(option => {                    
                    option.removeAttribute('disabled');
                    option.style.display = '';
                });
                optionsModalFrom.forEach(option => {                    
                    option.removeAttribute('disabled');
                    option.style.display = '';
                });
                return;
            }

            // set the options in bedroomFrom that have a value above the selected bedroomFrom to disabled and hide them
            optionsFrom.forEach(option => {
                if (option.value > this.bedroomModalTo.value) {
                    if (option.value !== '') {
                        option.setAttribute('disabled', true);
                        option.removeAttribute('selected');
                        option.selected = false;
                        option.style.display = 'none';
                    }                    
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = '';
                }
            });

            optionsModalFrom.forEach(option => {
                if (option.value > this.bedroomModalTo.value) {
                    if (option.value !== '') {
                        option.setAttribute('disabled', true);
                        option.removeAttribute('selected');
                        option.selected = false;
                        option.style.display = 'none';
                    }                    
                } else {
                    option.removeAttribute('disabled');
                    option.style.display = '';
                }
            });

        });
        
    }


    _openDropdown() {
        this.dropdown.classList.add('active');
        this.trigger.classList.add('active');
        this.outer.classList.add('bedroom-active');
        if (this.dropdown.classList.contains('active')) {
            const select = this.dropdown.querySelector('select');
            select[0].focus();
        }
    }

    _closeDropdown() {
        this.dropdown.classList.remove('active');
        this.trigger.classList.remove('active');
        this.outer.classList.remove('bedroom-active');
    }


    _setText(min, max) {

        const text = document.querySelector('.js-bedroom-text');

        if ( min === '' && max === '') {
            text.textContent = 'Any';
            return;
        }
        
        if (min === '0' && max === '') {
            text.textContent = 'Studio';
            return;
        }        
        
        if ((min === '' || min === '0') && max !== '') {            
            text.innerHTML = `<span class="small">up to</span> ${max}`;
            return;
        }
        
        if (min === max) {
            text.textContent = min;
            return;
        }

        if (min !== '' && max === '') {
            text.textContent = `${min}+`;
            return;
        }

        if ( (min !== '0' || min !== '0')  && (max !== '')) {

            if (max === '8') {
                text.textContent = `${min} - ${max}+`;
                return;
            }
            text.textContent = `${min} - ${max}`;
            return;
        }
        
    }
}
